import React, { memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './sidebar.module.scss';

interface IProps {
    className?: string;
    children: React.ReactNode;
    domRef?: any;
}

function Sidebar(props: IProps) {
    const { className, children, domRef, ...rest } = props;
    return (
        <Element
            {...rest}
            domRef={domRef}
            renderAs="aside"
            className={classnames(styles['bm-sidebar'], className)}
        >
            {children}
        </Element>
    );
}

export default memo(Sidebar);
